module.exports = __webpack_public_path__ + "static/media/turkey_icon.53cb5d99.png";